import { defineStyle, defineStyleConfig } from "@chakra-ui/styled-system"

const baseStyle = defineStyle({
  fontFamily: "body",
})

const sizes = {
  "6xl": defineStyle({
    fontSize: "60px",
    lineHeight: 1.5,
  }),
  "5xl": defineStyle({
    fontSize: "48px",
    lineHeight: 1.5,
  }),
  "4xl": defineStyle({
    fontSize: "36px",
    lineHeight: 1.5,
  }),
  "3xl": defineStyle({
    fontSize: "30px",
    lineHeight: 1.5,
  }),
  "2xl": defineStyle({
    fontSize: "24px",
    lineHeight: { mobile: 1.2, desktop: 1 },
  }),
  xl: defineStyle({
    fontSize: "20px",
    lineHeight: 1.5,
  }),
  lg: defineStyle({
    fontSize: "18px",
    lineHeight: 1.5,
  }),
  md: defineStyle({
    fontSize: "16px",
    lineHeight: 1.5,
  }),
  sm: defineStyle({
    fontSize: "14px",
    lineHeight: 1.5,
  }),
  xs: defineStyle({
    fontSize: "12px",
    lineHeight: 1.5,
  }),
}

export const Text = defineStyleConfig({
  baseStyle,
  sizes,
  defaultProps: {
    size: "md",
  },
});
